import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

export const UPDATE_ASSESSMENT_MUTATE = gql`
  mutation updateAssessment($input: UpdateAssessmentInput!) {
    updateAssessment(input: $input) {
      assessment {
        id
        assessmentOptions {
          notificationEmails
          reportTypes
          jobProfileIdForSingleJobProfileReports
          jobProfileIdsForMultipleJobProfileReports
          sendReportsWhenAssessmentIsComplete
          sendingIndividualReport
          printerFriendlyReport
          reportPreferLocale
        }
      }
    }
  }
`;

export const UPDATE_SUBSCRIBE_ASSESSMENT = gql`
  mutation($input: ToggleSubscribeAssessmentInput!) {
    toggleSubscribeAssessment(input: $input) {
      assessment {
        id
        subscribed
      }
    }
  }
`;


const updateAssessmentMutate = graphql(
  UPDATE_ASSESSMENT_MUTATE, { name: 'updateAssessment' },
);

const updateSubscribedMutate = graphql(
  UPDATE_SUBSCRIBE_ASSESSMENT, { name: 'updateSubcribedAssessment' },
);

export default compose(
  updateAssessmentMutate,
  updateSubscribedMutate,
);
